import { API_URL } from '../../../../utils/config';

export const GET_ALL_CALL_LOGS_URL = `${API_URL}/logs`;
export const ADD_CALL_LOG_URL = `${API_URL}/logs`;
export const GET_CALL_LOGS_BY_PARAMS = `${API_URL}/email/logs?from`;
export const GET_CALL_LOGS_BY_STAFF = `${API_URL}/staff_log`;
